import React from 'react';

/**
 * Arrivo Logo Component
 * Paper airplane icon with "arrivo" wordmark
 *
 * @param {string} size - 'sm' | 'md' | 'lg' | 'xl' (default: 'md')
 * @param {boolean} showText - Whether to show "arrivo" text (default: true)
 * @param {boolean} showTagline - Whether to show tagline (default: false)
 * @param {string} textColor - Color for text (default: 'text-white')
 */
const WanderLogo = ({
  size = 'md',
  showText = true,
  showTagline = false,
  textColor = 'text-white'
}) => {
  const sizes = {
    sm: { img: 'h-8', text: 'text-lg', gap: 'gap-1.5' },
    md: { img: 'h-11', text: 'text-2xl', gap: 'gap-2.5' },
    lg: { img: 'h-14', text: 'text-3xl', gap: 'gap-3' },
    xl: { img: 'h-20', text: 'text-4xl', gap: 'gap-4' },
  };

  const s = sizes[size] || sizes.md;

  return (
    <div className={`flex items-center justify-center ${s.gap}`}>
      {/* Logo Icon */}
      <img
        src="/arrivo-icon.png"
        alt="Arrivo"
        className={`${s.img} w-auto object-contain`}
      />

      {/* Text */}
      {showText && (
        <div className="flex flex-col">
          <span
            className={`${s.text} font-semibold ${textColor}`}
            style={{ fontFamily: "'GulfsDisplay', 'Batangas', sans-serif", letterSpacing: '0.05em' }}
          >
            arrivo
          </span>
          {showTagline && (
            <span className={`text-sm ${textColor} opacity-80`} style={{ fontFamily: "'Raleway', sans-serif", letterSpacing: '-0.01em' }}>
              plan less. explore more.
            </span>
          )}
        </div>
      )}
    </div>
  );
};

export default WanderLogo;
